import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants.js';

export function fetchBannerProps() {
  return consultRequestCreator
    .get(urlConstants.BANNER_PROPS)
    .then(response => response.data.value_props.map(each => each.image_url));
}
